/* Component-specific styles only */
:host {
  display: block;
}
.preview-link {
  display: inline-block;
  margin-left: var(--margin-xl);
  color: var(--color-bg-accent);
  text-decoration: none;
}
.preview-link:hover {
  text-decoration: underline;
}
.color-item label {
  font-size: var(--font-size);
  color: var(--color-text-secondary);
  text-align: center;
}
.shape-selector {
  display: flex;
  gap: var(--margin);
  flex-wrap: wrap;
}
.shape-option {
  display: flex;
  align-items: center;
  gap: var(--margin-s);
  padding: var(--padding-l) var(--padding-xl);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius);
  cursor: pointer;
  font-size: var(--font-size);
  transition:
    border-color 0.15s,
    background 0.15s;
}
.shape-option:hover {
  border-color: var(--color-bg-accent);
}
.shape-option.active,
.shape-option:has(input:checked) {
  border-color: var(--color-bg-accent);
  background: color-mix(in srgb, var(--color-bg-accent) 10%, transparent);
}
.shape-option input[type="radio"] {
  accent-color: var(--color-bg-accent);
}
.shape-hint {
  display: block;
  margin-top: var(--margin-s);
  color: var(--color-text-secondary);
  font-size: var(--font-size-s);
}
#removeLogoBtn,
#removeBgBtn {
  margin-top: var(--margin-s);
}
.toggle-option {
  display: flex;
  width: 100%;
  align-items: center;
  justify-self: flex-start;
  gap: var(--margin-s);
  cursor: pointer;
  font-size: var(--font-size);
}
.toggle-option input[type="checkbox"] {
  width: auto;
}
.border-controls {
  display: flex;
  gap: var(--margin-xl);
  flex-wrap: wrap;
  margin-top: var(--margin-s);
}
.border-control-item {
  display: flex;
  flex-direction: column;
  gap: var(--margin-s);
}
.border-control-item input[type="range"] {
  accent-color: var(--color-bg-accent);
  min-width: 120px;
  max-width: 180px;
}
.blur-range {
  display: block;
  width: 100%;
  max-width: 260px;
  accent-color: var(--color-bg-accent);
  margin-top: var(--margin-s);
}
@media (max-width: 768px) {
  .preview-link {
    display: block;
    margin-left: 0;
    margin-top: var(--padding-l);
    text-align: center;
  }
}
